import "./login.css";
import imgLoginBackLeft from "../../../assets/imgs/login/login-back-left.jpg";
import groupAmc from "../../../assets/imgs/login/logo-amc-blanco.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import planeImg from "../../../assets/imgs/login/login-bg-img.png";
import logoAmc from "../../../assets/imgs/login/logo-amc.png";
import pinkLines from "../../../assets/imgs/login/pink-lines.svg";
import logoHorus from "../../../assets/imgs/login/horus-logo.svg";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { TfiEmail } from "react-icons/tfi";
import { SlLock } from "react-icons/sl";

function Login() {
  const { loginWithRedirect } = useAuth0();

  useState(() => {
    localStorage.clear();
  });

  /* const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  }; */

  return (
    <>
    <div className="login-container container-fluid gx-0">
      <div className="row vh-100 g-0">
        {/* === COLUMNA IZQUIERDA (IMAGEN Y LOGOS) === */}
        <div className="col-12 col-lg-7 left-column">
          <div className="image-wrapper">
            <img src={planeImg} alt="Avión de Aeromexico sobre las nubes" className="plane-image" />
          </div>
          <div className="logo-wrapper text-center">
            <img src={logoAmc} alt="Logo de Aeromexico Cargo" className="logo-amc" />
            <img src={pinkLines} className="pink-lines" />
          </div>
        </div>

        {/* === COLUMNA DERECHA (FORMULARIO) === */}
        <div className="col-12 col-lg-5 d-flex justify-content-center align-items-center position-relative">
          <div className="login-form-container">
            <img src={logoHorus} className="logo-horus" />
            <div className="form-container">
              <form className="login-form">
                {/* <div className="input-group">
                  <label htmlFor="email" className="lbl-form">Correo electrónico</label>
                  <div className="input-with-icon">
                    <TfiEmail className="icon" />
                    <input
                      type="email"
                      id="email"
                      placeholder="Ingresa correo electrónico"
                    />
                  </div>
                </div>

                <div className="input-group">
                  <label htmlFor="password" className="lbl-form">Contraseña</label>
                  <div className="input-with-icon">
                    <SlLock className="icon" />
                    <input
                      type={passwordVisible ? 'text' : 'password'}
                      id="password"
                      placeholder="Ingresa contraseña"
                    />
                    <span onClick={togglePasswordVisibility} className="password-toggle-icon">
                      {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
                
                <a href="#" className="forgot-password">¿Has olvidado tu contraseña?</a> */}

                <button onClick={() => loginWithRedirect()} className="login-button">
                  Iniciar sesión
                </button>
              </form>
            </div>
          </div>
          <div className="copyright-text">
            <p>©Copyright {new Date().getFullYear()} | Derechos Reservados, Aeroméxico Cargo.</p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Login;
